module.exports = __webpack_public_path__ + "static/media/outcome_version_2.bc3de186.png";